import React from 'react';
import { IconProps } from './types';

const LocationIcon: React.FC<IconProps> = props => {
  const { width = 20, height = 20 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_309_24852" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_309_24852)">
        <path
          d="M9.99992 17.7709C9.80547 17.7709 9.61103 17.7361 9.41659 17.6667C9.22214 17.5972 9.04853 17.4931 8.89575 17.3542C7.99297 16.5209 7.19436 15.7084 6.49992 14.9167C5.80547 14.125 5.22561 13.3577 4.76034 12.6146C4.29506 11.8715 3.94089 11.1563 3.69784 10.4688C3.45478 9.78127 3.33325 9.12502 3.33325 8.50002C3.33325 6.41669 4.00339 4.75697 5.34367 3.52085C6.68395 2.28474 8.23603 1.66669 9.99992 1.66669C11.7638 1.66669 13.3159 2.28474 14.6562 3.52085C15.9964 4.75697 16.6666 6.41669 16.6666 8.50002C16.6666 9.12502 16.5451 9.78127 16.302 10.4688C16.0589 11.1563 15.7048 11.8715 15.2395 12.6146C14.7742 13.3577 14.1944 14.125 13.4999 14.9167C12.8055 15.7084 12.0069 16.5209 11.1041 17.3542C10.9513 17.4931 10.7777 17.5972 10.5833 17.6667C10.3888 17.7361 10.1944 17.7709 9.99992 17.7709ZM9.99992 10C10.4583 10 10.8506 9.83683 11.177 9.51044C11.5034 9.18405 11.6666 8.79169 11.6666 8.33335C11.6666 7.87502 11.5034 7.48266 11.177 7.15627C10.8506 6.82988 10.4583 6.66669 9.99992 6.66669C9.54158 6.66669 9.14922 6.82988 8.82284 7.15627C8.49645 7.48266 8.33325 7.87502 8.33325 8.33335C8.33325 8.79169 8.49645 9.18405 8.82284 9.51044C9.14922 9.83683 9.54158 10 9.99992 10Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default LocationIcon;
